<div [formGroup]="form">
    <label class="mydyn-radio-label">{{domanda.label}}</label>
    <mat-radio-group [formControlName]="domanda.key" class="mydyn-radio-group">
      <mat-radio-button class="mydyn-radio-button" *ngFor="let opt of domanda.options" [value]="opt.key">
        {{opt.value}}
      </mat-radio-button>
      <!-- <mat-error *ngIf="form.get(domanda.key).hasError('required')">Il codice fiscale è obbligatorio</mat-error> -->
    </mat-radio-group>
  <!-- <div class="errorMessage" *ngIf="!isValid">Domanda obbligatoria</div> -->
</div>
